var _defs, _defs2, _defs3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIfpb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17.34mm",
    height: "21.3mm",
    viewBox: "8017 11121 1950 1950",
    preserveAspectRatio: "xMidYMid",
    fillRule: "evenodd",
    strokeWidth: 28.222,
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsOoo: "http://xml.openoffice.org/svg/export",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsPresentation: "http://sun.com/xmlns/staroffice/presentation",
    xmlnsSmil: "http://www.w3.org/2001/SMIL20/",
    xmlnsAnim: "urn:oasis:names:tc:opendocument:xmlns:animation:1.0",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "EmbeddedFont_1",
    horizAdvX: 2048
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "OpenSans embedded",
    unitsPerEm: 2048,
    fontWeight: "normal",
    fontStyle: "normal",
    ascent: 2170,
    descent: 609
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 2048,
    d: "M 0,0 L 2047,0 2047,2047 0,2047 0,0 Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xED",
    horizAdvX: 424,
    d: "M 342,0 L 176,0 176,1096 342,1096 342,0 Z M 169,1266 C 201,1307 236,1357 273,1416 310,1475 339,1526 360,1569 L 562,1569 562,1548 C 533,1505 489,1451 431,1388 373,1325 323,1276 280,1241 L 169,1241 169,1266 Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "r",
    horizAdvX: 662,
    d: "M 676,1116 C 725,1116 768,1112 807,1104 L 784,950 C 739,960 699,965 664,965 575,965 500,929 437,857 374,785 342,695 342,588 L 342,0 176,0 176,1096 313,1096 332,893 340,893 C 381,964 430,1019 487,1058 544,1097 607,1116 676,1116 Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "b",
    horizAdvX: 980,
    d: "M 686,1114 C 830,1114 942,1065 1022,967 1101,868 1141,729 1141,549 1141,369 1101,229 1021,130 940,30 829,-20 686,-20 615,-20 550,-7 491,20 432,46 382,86 342,141 L 330,141 295,0 176,0 176,1556 342,1556 342,1178 C 342,1093 339,1017 334,950 L 342,950 C 419,1059 534,1114 686,1114 Z M 662,975 C 549,975 467,943 417,878 367,813 342,703 342,549 342,395 368,285 419,219 470,152 553,119 666,119 768,119 844,156 894,231 944,305 969,412 969,551 969,694 944,800 894,870 844,940 767,975 662,975 Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "a",
    horizAdvX: 901,
    d: "M 850,0 L 817,156 809,156 C 754,87 700,41 646,17 591,-8 523,-20 442,-20 333,-20 248,8 187,64 125,120 94,200 94,303 94,524 271,640 625,651 L 811,657 811,725 C 811,811 793,875 756,916 719,957 659,977 578,977 487,977 383,949 268,893 L 217,1020 C 271,1049 330,1072 395,1089 459,1106 523,1114 588,1114 719,1114 816,1085 879,1027 942,969 973,876 973,748 L 973,0 850,0 Z M 475,117 C 578,117 660,145 719,202 778,259 807,338 807,440 L 807,539 641,532 C 509,527 414,507 356,471 297,434 268,378 268,301 268,241 286,195 323,164 359,133 410,117 475,117 Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "P",
    horizAdvX: 954,
    d: "M 1128,1036 C 1128,888 1078,774 977,695 876,615 731,575 543,575 L 371,575 371,0 201,0 201,1462 580,1462 C 945,1462 1128,1320 1128,1036 Z M 371,721 L 524,721 C 675,721 784,745 851,794 918,843 952,921 952,1028 952,1125 920,1197 857,1244 794,1291 695,1315 561,1315 L 371,1315 371,721 Z"
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "EmbeddedFont_2",
    horizAdvX: 2048
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "OpenSans embedded",
    unitsPerEm: 2048,
    fontWeight: "bold",
    fontStyle: "normal",
    ascent: 2170,
    descent: 609
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 2048,
    d: "M 0,0 L 2047,0 2047,2047 0,2047 0,0 Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "U",
    horizAdvX: 1218,
    d: "M 1374,1462 L 1374,516 C 1374,408 1350,313 1302,232 1253,151 1183,88 1092,45 1001,2 893,-20 768,-20 580,-20 434,28 330,125 226,221 174,353 174,520 L 174,1462 483,1462 483,567 C 483,454 506,372 551,319 596,266 671,240 776,240 877,240 951,267 997,320 1042,373 1065,456 1065,569 L 1065,1462 1374,1462 Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "T",
    horizAdvX: 1139,
    d: "M 748,0 L 438,0 438,1204 41,1204 41,1462 1145,1462 1145,1204 748,1204 748,0 Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "S",
    horizAdvX: 980,
    d: "M 1047,406 C 1047,274 1000,170 905,94 810,18 677,-20 508,-20 352,-20 214,9 94,68 L 94,356 C 193,312 276,281 345,263 413,245 475,236 532,236 600,236 652,249 689,275 725,301 743,340 743,391 743,420 735,445 719,468 703,490 680,511 649,532 618,553 554,586 459,631 370,673 303,713 258,752 213,791 178,836 151,887 124,938 111,998 111,1067 111,1196 155,1298 243,1372 330,1446 451,1483 606,1483 682,1483 755,1474 824,1456 893,1438 965,1413 1040,1380 L 940,1139 C 862,1171 798,1193 747,1206 696,1219 645,1225 596,1225 537,1225 492,1211 461,1184 430,1157 414,1121 414,1077 414,1050 420,1026 433,1006 446,985 466,966 494,947 521,928 587,893 690,844 827,779 920,713 971,648 1022,582 1047,501 1047,406 Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "R",
    horizAdvX: 1191,
    d: "M 494,813 L 594,813 C 692,813 764,829 811,862 858,895 881,946 881,1016 881,1085 857,1135 810,1164 762,1193 688,1208 588,1208 L 494,1208 494,813 Z M 494,561 L 494,0 184,0 184,1462 610,1462 C 809,1462 956,1426 1051,1354 1146,1281 1194,1171 1194,1024 1194,938 1170,862 1123,795 1076,728 1009,675 922,637 1142,308 1285,96 1352,0 L 1008,0 659,561 494,561 Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "O",
    horizAdvX: 1403,
    d: "M 1511,733 C 1511,491 1451,305 1331,175 1211,45 1039,-20 815,-20 591,-20 419,45 299,175 179,305 119,492 119,735 119,978 179,1164 300,1293 420,1421 592,1485 817,1485 1042,1485 1214,1420 1333,1291 1452,1162 1511,976 1511,733 Z M 444,733 C 444,570 475,447 537,364 599,281 692,240 815,240 1062,240 1186,404 1186,733 1186,1062 1063,1227 817,1227 694,1227 601,1186 538,1103 475,1020 444,896 444,733 Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "N",
    horizAdvX: 1324,
    d: "M 1481,0 L 1087,0 451,1106 442,1106 C 455,911 461,771 461,688 L 461,0 184,0 184,1462 575,1462 1210,367 1217,367 C 1207,557 1202,691 1202,770 L 1202,1462 1481,1462 1481,0 Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "L",
    horizAdvX: 927,
    d: "M 184,0 L 184,1462 494,1462 494,256 1087,256 1087,0 184,0 Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "I",
    horizAdvX: 345,
    d: "M 184,0 L 184,1462 494,1462 494,0 184,0 Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "F",
    horizAdvX: 874,
    d: "M 489,0 L 184,0 184,1462 1022,1462 1022,1208 489,1208 489,831 985,831 985,578 489,578 489,0 Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "E",
    horizAdvX: 874,
    d: "M 1026,0 L 184,0 184,1462 1026,1462 1026,1208 494,1208 494,887 989,887 989,633 494,633 494,256 1026,256 1026,0 Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "D",
    horizAdvX: 1244,
    d: "M 1397,745 C 1397,504 1329,320 1192,192 1055,64 857,0 598,0 L 184,0 184,1462 643,1462 C 882,1462 1067,1399 1199,1273 1331,1147 1397,971 1397,745 Z M 1075,737 C 1075,1051 936,1208 659,1208 L 494,1208 494,256 627,256 C 926,256 1075,416 1075,737 Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "A",
    horizAdvX: 1430,
    d: "M 1079,0 L 973,348 440,348 334,0 0,0 516,1468 895,1468 1413,0 1079,0 Z M 899,608 C 801,923 746,1102 734,1143 721,1184 712,1217 707,1241 685,1156 622,945 518,608 L 899,608 Z"
  })))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", {
    className: "EmbeddedBulletChars"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bullet-char-template-57356",
    transform: "scale(0.00048828125,-0.00048828125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 580,1141 L 1163,571 580,0 -4,571 580,1141 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bullet-char-template-57354",
    transform: "scale(0.00048828125,-0.00048828125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8,1128 L 1137,1128 1137,0 8,0 8,1128 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bullet-char-template-10146",
    transform: "scale(0.00048828125,-0.00048828125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 174,0 L 602,739 174,1481 1456,739 174,0 Z M 1358,739 L 309,1346 659,739 1358,739 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bullet-char-template-10132",
    transform: "scale(0.00048828125,-0.00048828125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2015,739 L 1276,0 717,0 1260,543 174,543 174,936 1260,936 717,1481 1274,1481 2015,739 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bullet-char-template-10007",
    transform: "scale(0.00048828125,-0.00048828125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,-2 C -7,14 -16,27 -25,37 L 356,567 C 262,823 215,952 215,954 215,979 228,992 255,992 264,992 276,990 289,987 310,991 331,999 354,1012 L 381,999 492,748 772,1049 836,1024 860,1049 C 881,1039 901,1025 922,1006 886,937 835,863 770,784 769,783 710,716 594,584 L 774,223 C 774,196 753,168 711,139 L 727,119 C 717,90 699,76 672,76 641,76 570,178 457,381 L 164,-76 C 142,-110 111,-127 72,-127 30,-127 9,-110 8,-76 1,-67 -2,-52 -2,-32 -2,-23 -1,-13 0,-2 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bullet-char-template-10004",
    transform: "scale(0.00048828125,-0.00048828125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 285,-33 C 182,-33 111,30 74,156 52,228 41,333 41,471 41,549 55,616 82,672 116,743 169,778 240,778 293,778 328,747 346,684 L 369,508 C 377,444 397,411 428,410 L 1163,1116 C 1174,1127 1196,1133 1229,1133 1271,1133 1292,1118 1292,1087 L 1292,965 C 1292,929 1282,901 1262,881 L 442,47 C 390,-6 338,-33 285,-33 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bullet-char-template-9679",
    transform: "scale(0.00048828125,-0.00048828125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 813,0 C 632,0 489,54 383,161 276,268 223,411 223,592 223,773 276,916 383,1023 489,1130 632,1184 813,1184 992,1184 1136,1130 1245,1023 1353,916 1407,772 1407,592 1407,412 1353,268 1245,161 1136,54 992,0 813,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bullet-char-template-8226",
    transform: "scale(0.00048828125,-0.00048828125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 346,457 C 273,457 209,483 155,535 101,586 74,649 74,723 74,796 101,859 155,911 209,963 273,989 346,989 419,989 480,963 531,910 582,859 608,796 608,723 608,648 583,586 532,535 482,483 420,457 346,457 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bullet-char-template-8211",
    transform: "scale(0.00048828125,-0.00048828125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -4,459 L 1135,459 1135,606 -4,606 -4,459 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bullet-char-template-61548",
    transform: "scale(0.00048828125,-0.00048828125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 173,740 C 173,903 231,1043 346,1159 462,1274 601,1332 765,1332 928,1332 1067,1274 1183,1159 1299,1043 1357,903 1357,740 1357,577 1299,437 1183,322 1067,206 928,148 765,148 601,148 462,206 346,322 231,437 173,577 173,740 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Page"
  }, /*#__PURE__*/React.createElement("g", {
    className: "com.sun.star.drawing.ClosedBezierShape"
  }, /*#__PURE__*/React.createElement("g", {
    id: "id3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "BoundingBox",
    stroke: "none",
    fill: "none",
    x: 8792,
    y: 11132,
    width: 237,
    height: 238
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,160,65)",
    stroke: "none",
    d: "M 9028,11346 C 9028,11358 9018,11369 9005,11369 L 8815,11369 C 8802,11369 8792,11358 8792,11346 L 8792,11155 C 8792,11143 8802,11132 8815,11132 L 9005,11132 C 9018,11132 9028,11143 9028,11155 L 9028,11346 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "com.sun.star.drawing.ClosedBezierShape"
  }, /*#__PURE__*/React.createElement("g", {
    id: "id4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "BoundingBox",
    stroke: "none",
    fill: "none",
    x: 9074,
    y: 11132,
    width: 237,
    height: 238
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,160,65)",
    stroke: "none",
    d: "M 9310,11346 C 9310,11358 9300,11369 9287,11369 L 9098,11369 C 9085,11369 9074,11358 9074,11346 L 9074,11155 C 9074,11143 9085,11132 9098,11132 L 9287,11132 C 9300,11132 9310,11143 9310,11155 L 9310,11346 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "com.sun.star.drawing.ClosedBezierShape"
  }, /*#__PURE__*/React.createElement("g", {
    id: "id5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "BoundingBox",
    stroke: "none",
    fill: "none",
    x: 9074,
    y: 11697,
    width: 237,
    height: 237
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,160,65)",
    stroke: "none",
    d: "M 9310,11910 C 9310,11923 9300,11933 9287,11933 L 9098,11933 C 9085,11933 9074,11923 9074,11910 L 9074,11720 C 9074,11707 9085,11697 9098,11697 L 9287,11697 C 9300,11697 9310,11707 9310,11720 L 9310,11910 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "com.sun.star.drawing.ClosedBezierShape"
  }, /*#__PURE__*/React.createElement("g", {
    id: "id6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "BoundingBox",
    stroke: "none",
    fill: "none",
    x: 8509,
    y: 11415,
    width: 238,
    height: 237
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,160,65)",
    stroke: "none",
    d: "M 8746,11628 C 8746,11641 8735,11651 8723,11651 L 8532,11651 C 8520,11651 8509,11641 8509,11628 L 8509,11437 C 8509,11425 8520,11415 8532,11415 L 8723,11415 C 8735,11415 8746,11425 8746,11437 L 8746,11628 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "com.sun.star.drawing.ClosedBezierShape"
  }, /*#__PURE__*/React.createElement("g", {
    id: "id7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "BoundingBox",
    stroke: "none",
    fill: "none",
    x: 8792,
    y: 11415,
    width: 237,
    height: 237
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,160,65)",
    stroke: "none",
    d: "M 9028,11628 C 9028,11641 9018,11651 9005,11651 L 8815,11651 C 8802,11651 8792,11641 8792,11628 L 8792,11437 C 8792,11425 8802,11415 8815,11415 L 9005,11415 C 9018,11415 9028,11425 9028,11437 L 9028,11628 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "com.sun.star.drawing.ClosedBezierShape"
  }, /*#__PURE__*/React.createElement("g", {
    id: "id8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "BoundingBox",
    stroke: "none",
    fill: "none",
    x: 8509,
    y: 11697,
    width: 238,
    height: 237
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,160,65)",
    stroke: "none",
    d: "M 8746,11910 C 8746,11923 8735,11933 8723,11933 L 8532,11933 C 8520,11933 8509,11923 8509,11910 L 8509,11720 C 8509,11707 8520,11697 8532,11697 L 8723,11697 C 8735,11697 8746,11707 8746,11720 L 8746,11910 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "com.sun.star.drawing.ClosedBezierShape"
  }, /*#__PURE__*/React.createElement("g", {
    id: "id9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "BoundingBox",
    stroke: "none",
    fill: "none",
    x: 8792,
    y: 11697,
    width: 237,
    height: 237
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,160,65)",
    stroke: "none",
    d: "M 9028,11910 C 9028,11923 9018,11933 9005,11933 L 8815,11933 C 8802,11933 8792,11923 8792,11910 L 8792,11720 C 8792,11707 8802,11697 8815,11697 L 9005,11697 C 9018,11697 9028,11707 9028,11720 L 9028,11910 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "com.sun.star.drawing.ClosedBezierShape"
  }, /*#__PURE__*/React.createElement("g", {
    id: "id10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "BoundingBox",
    stroke: "none",
    fill: "none",
    x: 8509,
    y: 11980,
    width: 238,
    height: 237
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,160,65)",
    stroke: "none",
    d: "M 8746,12193 C 8746,12205 8735,12216 8723,12216 L 8532,12216 C 8520,12216 8509,12205 8509,12193 L 8509,12003 C 8509,11990 8520,11980 8532,11980 L 8723,11980 C 8735,11980 8746,11990 8746,12003 L 8746,12193 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "com.sun.star.drawing.ClosedBezierShape"
  }, /*#__PURE__*/React.createElement("g", {
    id: "id11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "BoundingBox",
    stroke: "none",
    fill: "none",
    x: 8792,
    y: 11980,
    width: 237,
    height: 237
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,160,65)",
    stroke: "none",
    d: "M 9028,12193 C 9028,12205 9018,12216 9005,12216 L 8815,12216 C 8802,12216 8792,12205 8792,12193 L 8792,12003 C 8792,11990 8802,11980 8815,11980 L 9005,11980 C 9018,11980 9028,11990 9028,12003 L 9028,12193 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "com.sun.star.drawing.ClosedBezierShape"
  }, /*#__PURE__*/React.createElement("g", {
    id: "id12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "BoundingBox",
    stroke: "none",
    fill: "none",
    x: 8498,
    y: 11121,
    width: 260,
    height: 261
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,25,30)",
    stroke: "none",
    d: "M 8757,11251 C 8757,11322 8699,11380 8628,11380 8557,11380 8498,11322 8498,11251 8498,11180 8557,11121 8628,11121 8699,11121 8757,11180 8757,11251 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "com.sun.star.drawing.TextShape"
  }, /*#__PURE__*/React.createElement("g", {
    id: "id13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "BoundingBox",
    stroke: "none",
    fill: "none",
    x: 8452,
    y: 12915,
    width: 875,
    height: 336
  }), /*#__PURE__*/React.createElement("text", {
    className: "TextShape"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "TextParagraph",
    fontFamily: "OpenSans, sans-serif",
    fontSize: "247px",
    fontWeight: 400
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "TextPosition",
    x: 8452,
    y: 13177
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "rgb(40,29,21)",
    stroke: "none"
  }, "Para\xEDba")))))), /*#__PURE__*/React.createElement("g", {
    className: "com.sun.star.drawing.TextShape"
  }, /*#__PURE__*/React.createElement("g", {
    id: "id14"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "BoundingBox",
    stroke: "none",
    fill: "none",
    x: 8017,
    y: 12263,
    width: 1734,
    height: 447
  }), /*#__PURE__*/React.createElement("text", {
    className: "TextShape"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "TextParagraph",
    fontFamily: "OpenSans, sans-serif",
    fontSize: "328px",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "TextPosition",
    x: 8017,
    y: 12610
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "rgb(40,29,21)",
    stroke: "none"
  }, "INSTITUTO")))))), /*#__PURE__*/React.createElement("g", {
    className: "com.sun.star.drawing.TextShape"
  }, /*#__PURE__*/React.createElement("g", {
    id: "id15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "BoundingBox",
    stroke: "none",
    fill: "none",
    x: 8180,
    y: 12545,
    width: 1413,
    height: 447
  }), /*#__PURE__*/React.createElement("text", {
    className: "TextShape"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "TextParagraph",
    fontFamily: "OpenSans, sans-serif",
    fontSize: "328px",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "TextPosition",
    x: 8100,
    y: 12900
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "rgb(40,29,21)",
    stroke: "none"
  }, "FEDERAL")))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIfpb);
export default __webpack_public_path__ + "static/media/ifpb.04b4b408aa05832b730f4b10f69b01bd.svg";
export { ForwardRef as ReactComponent };